import { styled } from '@mui/material';
import { up } from '../../../theme';

export const globalClasses = {
  root: 'root',
  mainGridContainer: 'allInvoicesGridContainer',
  mainGridContainerInnerBox: 'allInvoicesGridContainerInnerBox',
  visibility: 'visibility',
  notVisibility: 'notVisibility',
  whiteTextColor: 'whiteTextColor',
  displayFlex: 'displayFlex',
  displayAlignItem: 'displayAlignItem',
  displayJustifyContent: 'displayJustifyContent',
  gridCheckBox: 'gridCheckBox',
  backdrop: 'backdrop',
  displayFlexAlignJustifyContent: 'displayFlexAlignJustifyContent',
  cursorPointerClass: 'cursorPointerClass',
  cursorAutoClass: 'cursorAutoClass',
  cursorDisabledClass: 'cursorDisabledClass',
  agGridCellCustomTypo: 'agGridCellCustomTypo',
};

export const MainRoot = styled('div')(({ theme }) => ({
  [`&.${globalClasses.root}`]: {},
  [`& .${globalClasses.mainGridContainer}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
  },
  [`& .${globalClasses.mainGridContainerInnerBox}`]: {
    backgroundColor: theme.palette.lynxWhite.main,
  },
  [`& .${globalClasses.visibility}`]: {
    visibility: 'visible',
  },
  [`& .${globalClasses.notVisibility}`]: {
    visibility: 'hidden',
  },
  [`& .${globalClasses.whiteTextColor}`]: {
    color: theme.palette.secondaryWhite.main,
  },
  [`& .${globalClasses.displayFlex}`]: {
    display: 'flex',
  },
  [`& .${globalClasses.displayAlignItem}`]: {
    alignItems: 'center',
  },
  [`& .${globalClasses.displayJustifyContent}`]: {
    justifyContent: 'center',
  },
  [`& .${globalClasses.gridCheckBox}`]: {
    padding: 0,
    [up('xs')]: {
      width: '16px',
      height: '11px',
    },
    [up('sm')]: {
      width: '16px',
      height: '11px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
    },
    [up('lg')]: {
      width: '15px',
      height: '15px',
    },
    [up('xl')]: {
      width: '16px',
      height: '16px',
    },
    [up('xxl')]: {
      width: '19px',
      height: '19px',
    },
  },
  [`& .${globalClasses.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.secondaryWhite.main,
  },
  [`& .${globalClasses.displayFlexAlignJustifyContent}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  [`& .${globalClasses.cursorPointerClass}`]: {
    cursor: 'pointer',
  },
  [`& .${globalClasses.cursorAutoClass}`]: {
    cursor: 'auto',
  },
  [`& .${globalClasses.cursorDisabledClass}`]: {
    cursor: 'not-allowed',
  },
  [`& .${globalClasses.agGridCellCustomTypo}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
